/*
* Anchor Navigation Section
*
*/
(function() {
    
    class AnchorNavigation {

      constructor() {
        this.navLinks = document.querySelectorAll('[data-anchor-link]');
        this.contentSections = [];
        this.activeLink = null;
        this.navHeight = document.querySelector('.anchor-navigation-section')?.offsetHeight || 0;                
        this.init();
      }
      
      init() {

        if (this.navLinks.length === 0) return;        
        
        this.navLinks.forEach(link => {
          const targetId = link.getAttribute('href')?.substring(1);
          if (targetId) {
            const targetSection = document.getElementById(targetId);
            if (targetSection) {
              this.contentSections.push({
                id: targetId,
                element: targetSection,
                link
              });
            }
          }
        });
        
        this.navLinks.forEach(link => {
          link.addEventListener('click', this.handleLinkClick.bind(this));
        });        
        
        window.addEventListener('scroll', this.handleScroll.bind(this));        
        
        this.handleScroll();

      }
      
      handleLinkClick(event) {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute('href')?.substring(1);
        if (!targetId) return;
        
        const targetElement = document.getElementById(targetId);
        if (!targetElement) return;
        
        const offsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset - this.navHeight - 20;
        
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
      
      handleScroll() {
        const scrollPosition = window.scrollY + this.navHeight + 50;        
        
        let currentSection = null;
        
        for (const section of this.contentSections) {
          const { element } = section;
          if (!element) continue;
          
          const offsetTop = element.offsetTop;
          const offsetBottom = offsetTop + element.offsetHeight;
          
          if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
            currentSection = section;
            break;
          }
        }
        
        if (currentSection) {
          if (this.activeLink) {
            this.activeLink.classList.remove('active');
          }
          
          currentSection.link.classList.add('active');
          this.activeLink = currentSection.link;
        }

      }
    }
  
    document.addEventListener('DOMContentLoaded', () => {
      new AnchorNavigation();
    });

})();